import CustomApiError from './CustomError';

export default class PixSugestionsError extends CustomApiError {
  toDictionary() {
    return {
      PAYMENT_ACCOUNT_NOT_FOUND: 'Conta de pagamento não encontrada.',
    };
  }
}
